import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { LegalEntitiesPage } from '@/pages/legal-entities/LegalEntitiesPage'

export const Route = createFileRoute('/legal-entities')({
  component: () => (
    <RequirePermission section="legal_entities" action="view">
      <LegalEntitiesPage />
    </RequirePermission>
  ),
})
